module.exports = __webpack_public_path__ + "img/mcwyj.252e2ff6.png";